import { Styles } from "@/shared/coralreef";
import { rem } from "csx";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { style } from "typestyle";
import { useLocalServers } from "./useLocalServers";

// Topbar picker for the akva-network-scanner page: lists the Electron local
// servers (machines). State and side effects live in useLocalServers.
export const LocalServerPicker: FC = () => {
  const { t } = useTranslation();
  const { servers, selectedMachineId, select } = useLocalServers();

  return (
    <select
      data-testid="local-server-picker"
      className={picker}
      value={selectedMachineId ?? ""}
      onChange={(e) => select(e.target.value ? Number(e.target.value) : null)}
    >
      <option value="">{t("Select machine")}</option>
      {servers.map((s) => (
        <option key={s.machine_id} value={s.machine_id}>
          {s.name} ({s.ip})
        </option>
      ))}
    </select>
  );
};

const picker = style({
  height: rem(2.25),
  minWidth: rem(12),
  padding: `0 ${rem(0.5)}`,
  background: Styles.Colours.darkBlue,
  color: Styles.Colours.textLight,
  border: `1px solid ${Styles.Colours.darkestBlue}`,
  borderRadius: rem(0.25),
  fontFamily: Styles.fontFamily,
});
